import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { MAX_LOAN_AMOUNT, MIN_LOAN_AMOUNT } from '../../../config/globals';

export const appliedAmountFieldOptions = {
  registerOptions: {
    max: MAX_LOAN_AMOUNT,
    min: MIN_LOAN_AMOUNT,
    valueAsNumber: true,
  },
} satisfies IFieldOptions;
